import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

import { 
    form, 
    formField, 
    formFieldLabel, 
    formFieldInput, 
    avatarUpload, 
    btnPrimary,
    guideHelpRow,
    guideHelpBtn
} from "./auth-forms.module.scss";

import useUser from "../hooks/use-user";
import ImageUploader from "../../../components/molecules/image-uploader";
import { uploadFileToApi } from "../../../services/fileupload-services";
import { getUserPhoto } from "../../../services/user-services";
import { useModalContext } from "../../../contexts/modal.context";
import { EModal } from "../../../models/modal.model";

const updateDataSchema = Yup.object({
    name: Yup.string(),
    email: Yup.string(),
});

const AccountDataForm = () => {
    const { t } = useI18next();
    const { updateProfile, data, profile } = useUser();
    const { addModal } = useModalContext();

    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [imageUrl, setImageUrl] = useState("");

    const handleOpenPhotoGuide = () => {
        addModal({
            key: EModal.PHOTO_GUIDE,
        });
    };

    const onUploadPhoto = (file: File) => {
        console.log("onUploadPhoto called: ", file);
        setUploadFile(file);
    }

    useEffect(() => {
        getUserPhoto(2)
            .then((response) => {
                if (response?.base64) {
                    setImageUrl(response.base64);
                }
            })
            .catch(() => {
                // 404 - użytkownik nie ma jeszcze zdjęcia, ignoruj
            });
    }, []);

    return (
        <Formik
            initialValues={{ name: profile?.firstName || "", email: data?.email || "" }}
            validationSchema={updateDataSchema}
            enableReinitialize={true}
            onSubmit={async (values, formikHelpers) => {
                await updateProfile(values);
                if (uploadFile) {
                    var uploadResponse = await uploadFileToApi(uploadFile);
                }
                console.log("Zaktualizowano profil i przesłano plik");
            }}
        >
            {(formik) => (
                <form className={form} onSubmit={formik.handleSubmit}>
                    <label className={formField}>
                        <span className={formFieldLabel}>Imię</span>
                        <input
                            type="text"
                            className={formFieldInput}
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </label>

                    <label className={formField}>
                        <span className={formFieldLabel}>Adres e-mail</span>
                        <input
                            type="email"
                            className={formFieldInput}
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled
                        />
                    </label>

                    <div className={formField}>
                        <span className={formFieldLabel}>Zdjęcie profilowe</span>
                        <div className={avatarUpload}>
                            <ImageUploader onUploadPhoto={onUploadPhoto} imageUrl={imageUrl} />
                        </div>
                        <div className={guideHelpRow}>
                            <button className={guideHelpBtn} type="button" onClick={handleOpenPhotoGuide}>
                                <span className="qmark">?</span>
                                Jak właściwie wybrać zdjęcie?
                            </button>
                        </div>
                    </div>

                    <button className={btnPrimary} type="submit">
                        Zapisz dane
                    </button>
                </form>
            )}
        </Formik>
    );
};

export default AccountDataForm;
